import { createFileRoute, Link } from "@tanstack/react-router";
import { MarketingHeader } from "@/components/marketing/marketing-header";
import { MarketingFooter } from "@/components/marketing/marketing-footer";
import { seoMeta } from "@/lib/seo/head";
import { POSTS } from "@/lib/seo/blog";
import { JsonLd, breadcrumbSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/blog/")({
  head: () => seoMeta({
    title: "Blog LexAIPro - AI, diritto e innovazione professionale",
    description: "Approfondimenti aggiornati su intelligenza artificiale per avvocati, AI Act, GDPR, casi pratici e novità di prodotto.",
    path: "/blog",
  }),
  component: BlogIndex,
});

function BlogIndex() {
  return (
    <div className="min-h-screen bg-background">
      <JsonLd data={breadcrumbSchema([{name:"Home",path:"/"},{name:"Blog",path:"/blog"}])} />
      <MarketingHeader />
      <main className="pt-32 pb-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-accent">Blog</p>
          <h1 className="font-display text-4xl font-semibold tracking-[-0.035em] text-foreground sm:text-5xl">Idee, ricerca e pratica</h1>
          <p className="mt-5 text-lg text-muted-foreground">Articoli pensati per professionisti legali italiani che vogliono usare l'AI con cognizione di causa.</p>
          <div className="mt-12 space-y-6">
            {POSTS.map((p) => (
              <Link key={p.slug} to="/blog/$slug" params={{ slug: p.slug }} className="block rounded-2xl border border-border bg-card p-6 transition-colors hover:border-accent">
                <time className="text-xs uppercase tracking-wider text-muted-foreground">{new Date(p.datePublished).toLocaleDateString("it-IT", { year: "numeric", month: "long", day: "numeric" })}</time>
                <h2 className="mt-2 font-display text-2xl font-semibold text-foreground">{p.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{p.excerpt}</p>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}
